import './notification.styles.scss';

export default angular.module('directives.notification', [])
  .directive('notification', ($rootScope) => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      scope: {
        notification: '<',
      },
      templateUrl: require('./notification.template.html'),
      link: (scope) => {
        scope.notificationService = $rootScope.notificationService;
      },
    };
  })
  .name;
